<!-- default modal -->
<div class="h-100 w-100" style="overflow-y: auto"><!-- Parent that resizes with the ngbModal, but the child will have min sizes with overflow scroll -->
    <div class="moduleDialogWindow d-flex flex-column justify-content-between" style="height: 500px">
        <!-- Close button -->
        <div class="position-absolute" style="top: 8px; right: 8px;">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="close()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
        </div>
        <div class="h-100 pr-4">
            <div class="lato-bold font-size-18 pb-2 border-bottom mb-3" style="width:100%; margin-left:16px; margin-top: 32px;">
                <span cvLocalizedText langSection="Tasks" langKey="Create_New_Task">Create New Task</span>
            </div>
                <div class="pl-4 ml-2">
                    <div class="lato-bold font-size-16 mb-1" cvLocalizedText langSection="Tasks" langKey="Assign_To">Assign To</div>
                    <div>{{selectedRow.groupName}}</div>
                    <div style="height:32px"></div>
                </div>
                <div class="pl-4 mb-1 ml-2">
                    <span class="lato-bold font-size-16" cvLocalizedText langSection="Tasks" langKey="Task_Name">Task Name</span>
                    <span class="color-redRyder font-size-12 ml-2" *ngIf="ts.save.Name === '' && !namePristine" cvLocalizedText langSection="Tasks" langKey="Name_Required">Name is required</span>
                </div>
                <div class="pl-4 mx-2" style="max-width:430px; margin-bottom:32px">
                    <input type="text" 
                    class="form-control" 
                    [ngClass]="{ 'is-invalid' : ts.save.Name.length <= 0 && !namePristine }" 
                    [(ngModel)]="ts.save.Name" 
                    (ngModelChange)="namePristine = false"
                    maxlength="50" 
                    placeholder={{getLocalizedString()}}/>
                </div>
                <div class="pl-4 mb-1 ml-2">
                    <span class="lato-bold font-size-16" cvLocalizedText  langSection="Tasks" langKey="Set_Date_Time">Set Date/Time</span>
                    <span class="color-redRyder font-size-12 ml-2">{{dateError}}</span>
                </div>
                <div class="d-flex flex-wrap pl-4 mb-2 mx-2">
                    <div class="d-flex flex-column mr-3">
                        <div class="color-no2Pencil font-size-12 mb-1" cvLocalizedText  langSection="Common" langKey="Start_Date">Start Date</div>
                        <div class="input-group">
                            <div class="search-box click-search justify-content-start">
                                <div class="input-group-append">
                                    <cv-baremetrics-calendar
                                    class="d-block daterange daterange--single" 
                                    [(currentDate)]="ts.save.StartDate"
                                    [required]="true"
                                    [placeholder]="'00/00/0000'"
                                    (dateChanged)="validateDates()"
                                ></cv-baremetrics-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column mr-3">
                        <div class="color-no2Pencil font-size-12 mb-1" cvLocalizedText  langSection="Common" langKey="End_Date">End Date</div>
                        <div class="input-group">
                            <div class="search-box click-search justify-content-start">
                                <div class="input-group-append">
                                    <cv-baremetrics-calendar
                                    class="d-block daterange daterange--single" 
                                    [(currentDate)]="ts.save.DueDate"
                                    [required]="false"
                                    [placeholder]="'00/00/0000'"
                                    (dateChanged)="validateDates()"
                                ></cv-baremetrics-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="color-no2Pencil font-size-12 mb-1" cvLocalizedText  langSection="Tasks" langKey="Time_Due">Time Due</div>
                        <div class="input-group">
                            <div class="justify-content-start">
                                <div class="input-group-append">
                                    <cv-time-picker 
                                    [(ngModel)]="ts.save.DueDate" 
                                    [disabled]="ts.save.DueDate == null"
                                    style="background-image:none"></cv-time-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-check pt-4" style="margin-left:32px" *ngIf="!ts.save.AssignToSelf">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="ts.save.Signoff" value="" id="{{'signoffCheck' + moduleKey}}" />
                    <label class="form-check-label" style="margin-left:5px" for="{{'signoffCheck' + moduleKey}}" cvLocalizedText  langSection="Tasks" langKey="Allow_Signoff">Allow Assignee To Signoff Task</label>
                </div>
                <div class="border-bottom mt-3 mb-3"></div>
            <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-text mr-2" (click)="close()" cvLocalizedText  langSection="Common" langKey="Cancel_Button">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="addTask()"
                    [attr.disabled]="ts.save.Name.length <= 0 || namePristine || dateError.length > 0 || !selectedRow || groupID === 0 ||  creatingTask ? true : null"
                    cvLocalizedText langSection="Common" langKey="Create">Create</button>
            </div>
        </div>
    </div>
</div>